import React from 'react';
import { useNavigate } from 'react-router-dom';

import ShortString from '@/components/common-components/ShortString/ShortString';

import { downloadFiles, formatNumber, getPlatformFromUrl, getPlatformImage } from '../../../../../utils/global';
import AvatarComponent from '../../../../common-components/AvatarComponent/AvatarComponent';
import CustomTooltip from '../../../../common-components/CustomTooltip/CustomTooltip';
import PersonIcon from '../../../../Icons/icons/PersonIcon';
import DownloadIcon from '../../../../Icons/icons/PlayerIcon/DownloadIcon';

const CardTopContent = ({ showDownload = true, profile, downloadUrl, entityUrl }) => {
  const onDownloadClick = () => {
    downloadFiles(downloadUrl);
  };

  const navigate = useNavigate();

  function navigateToIIV() {
    navigate(`/dashboard/profile/${profile.listId}/${profile._id}`);
  }

  const renderFollowers = (followers) => {
    if (!followers) return '--';

    return `${formatNumber(profile?.followers)} followers`;
  };

  return (
    <div className="card-top-profile-container">
      <div className="left-section">
        <div className="avatar-wrapper">
          <AvatarComponent size={30} src={profile?.imageUrl} alt={profile?.name} onClick={navigateToIIV} />
        </div>
        <div className="profile-info-section" onClick={() => window.open(entityUrl)}>
          <div className="profile-info-section-title">
            <img src={getPlatformImage(getPlatformFromUrl(entityUrl))} alt="" width={18} height={18} />@
            <ShortString name={profile?.username.replace('@', '')} stringLength={16} />
          </div>
          <div className="profile-info-section-sub-title">{renderFollowers(profile?.followers)}</div>
        </div>
      </div>
      <div className="right-section">
        <CustomTooltip title="View Profile">
          <PersonIcon onClick={navigateToIIV} />
        </CustomTooltip>
        {showDownload && (
          <CustomTooltip title="Download">
            <DownloadIcon width={18} height={18} onClick={onDownloadClick} />
          </CustomTooltip>
        )}
      </div>
    </div>
  );
};

export default CardTopContent;
